// Strangly enaugh this must be put at the begining
// if we want to force it at the begining of the head
// import '@/styles/reset.css'
import '@/styles/fonts.css'

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import { store } from '@/state/store'
import Main from '@/view/Main'
import ThemeProvider from '@/ui/Theme/ThemeProvider'

import ErrorBoundary from '@/ui/DevError/ErrorBoundary'

const isProduction = process.env.NODE_ENV === 'production'
const rootElement = document.getElementById('root')

const renderApplication = ApplicationComponent => {
  // Disregard HMR for production builds.
  if (isProduction) {
    render(
      <Provider store={store}>
        <ThemeProvider>
          <ApplicationComponent />
        </ThemeProvider>
      </Provider>,
      rootElement,
    )
  } else {
    console.log('rendering application')
    const AppContainer = require('react-hot-loader').AppContainer
    // Trick babel to avoid hoisting `<AppContainer />`
    // via `babel-plugin-transform-react-constant-elements`.
    // Found here:
    // ~ https://github.com/LWJGL/lwjgl3-www/
    const noHoist = {}

    render(
      <AppContainer {...noHoist}>
        <ErrorBoundary>
          <Provider store={store}>
            <ThemeProvider>
              <ApplicationComponent />
            </ThemeProvider>
          </Provider>
        </ErrorBoundary>
      </AppContainer>,
      rootElement,
    )
  }
}

// Render the application.
renderApplication(Main)

if (!isProduction && module.hot) {
  module.hot.accept('./view/Main', () => {
    const NewApp = require('./view/Main').default

    renderApplication(NewApp)
  })
}



// WEBPACK FOOTER //
// ./index.js